import React from 'react';

interface IPageProps {
    className?: string;
    style?: React.CSSProperties;
}

interface IPageSectionProps {
    width?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13 | 14;
}

const PageSection: React.FC<IPageSectionProps> = (props) => {
    return <div style={{ width: `${((props.width || 12) / 12) * 100}%` }}>{props.children}</div>;
};

PageSection.displayName = 'PageSection';

interface IPageComposition {
    Section?: React.FC<IPageSectionProps>;
}

const Page: React.FC<IPageProps> & IPageComposition = (props) => {
    return (
        <div className={`${props.className}`} style={props.style}>
            {props.children}
        </div>
    );
};

Page.defaultProps = {
    className: 'dlc-max-width',
};

Page.displayName = 'Page';
Page.Section = PageSection;
export default Page;



// WEBPACK FOOTER //
// ./src/components/common/Page.tsx